export default (() => {
  const forms = document.querySelectorAll('.email-subscribe-form')
  const grecaptcha = window.grecaptcha


  if (forms) {
    forms.forEach((form) => {
      form.addEventListener('submit', function (e) {
        // console.log(e)
        e.preventDefault()
        grecaptcha.ready(function() {
          grecaptcha.execute('6Ld5HRwrAAAAAAhKLsPHXkDWaN_r32LvJPOUJQ2h', {action: 'submit'}).then(function(token) {
            const csrfToken = form.querySelector("input[name='csrfToken']").value
            const emailInput = form.querySelector("input[name='email']")
            const button = form.querySelector('button')
            const email = emailInput.value.trim().toLowerCase()

            button.disabled = true
            button.innerText = 'Subscribing...'

            function failedMessage() {
              e.target.innerHTML = `
                            <div class="rounded-5 d-inline-flex align-content-center align-items-center justify-content-center p-2 px-3 bg-body-secondary bg-opacity-25" style="backdrop-filter: blur(8px);" data-zanim-xs='{"animation": "slide-up" }'>
                                <i class="ci-alert-circle display-6 text-danger p-0 m-0"></i>
                                <p class="ms-2 mb-0 fs-sm fw-light">Failed to subscribe <strong>${email.toLowerCase()}</strong>. Please try again.</p>
                            </div>
                        `
            }

            fetch('/sub', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Csrf-Token': csrfToken,
                'g-recaptcha-response': token
              },
              body: JSON.stringify({
                email
              })
            }).then(response => {
              if (!response.ok) {
                console.error('something bad happened', response.status, response.statusText)
                failedMessage()
              } else {

                emailInput.value = ''
                emailInput.placeholder = "You've successfully subscribed!"
                emailInput.disabled = true
                emailInput.readonly = true

                e.target.innerHTML = `
                            <div class="rounded-5 d-inline-flex align-content-center align-items-center justify-content-center p-2 px-3 bg-body-secondary bg-opacity-25" style="backdrop-filter: blur(8px);" data-zanim-xs='{"animation": "slide-up" }'>
                                <i class="ci-check-circle display-6 text-success p-0 m-0"></i>
                                <p class="ms-2 mb-0 fs-sm fw-light"><strong>${email.toLowerCase()}</strong> is now subscribed. We'll keep you updated.</p>
                            </div>
                        `
              }
            }).catch((error) => {
              console.error(error)
              failedMessage()
            })
          })
        })
      })
    })
  }

})()
